// libs
import { css, keyframes } from '@emotion/core';

export const marqueeGenerator = (containerWidth = '100vw') => keyframes`
    0% {
        transform: translate(${containerWidth}, 0);
    }
    100% {
        transform: translate(-100%, 0);
    }
`;

const marquee = marqueeGenerator();

export const DEFAULT_MARQUE_SPEED = 45;

// TODO: take props for marquee and convert it to styled component.
export const marqueeAnimation = css`
  animation: ${marquee} ${DEFAULT_MARQUE_SPEED}s linear infinite;
`;
